export enum SavingPlanPaymentIntervals{
    interval_monthly = 'interval_monthly',
    interval_yearly = 'interval_yearly',
}